import { Reducer } from "react";
import { ActionType } from "~@/types/universal";

export const combineReducer = <S>(...args: Reducer<S, ActionType>[]) => {
  return (state: S, action: ActionType) => {
    return args.reduce((s, reducer) => reducer(s, action) || s, state);
  };
};

export const showTotal = (total: number, range: number[]) => {
  const [begin, end] = range;
  return `第 ${begin}-${end}条/总共 ${total} 条`;
};
